var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinearIcon = function SvgLinearIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10402_25042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8249 21.1196C20.0649 20.9276 20.2569 20.7356 20.4489 20.4956C25.1529 15.7916 25.1529 8.20759 20.4489 3.50359C15.7449 -1.20041 8.16086 -1.20041 3.45686 3.50359C3.26486 3.74359 3.07286 3.93559 2.88086 4.17559L19.8249 21.1196Z",
    fill: "#5E6AD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3849 22.1752L1.82494 5.61523C1.48894 6.14323 1.20094 6.67123 0.960938 7.24723L16.7529 23.0392C17.3289 22.7992 17.8569 22.5112 18.3849 22.1752Z",
    fill: "#5E6AD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.928 23.6633L0.336 9.07129C0.144 9.79129 0.048 10.5113 0 11.2313L12.768 23.9993C13.488 23.9513 14.208 23.8553 14.928 23.6633Z",
    fill: "#5E6AD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1277 23.9041L0.0957031 13.8721C0.479703 16.3201 1.5837 18.6241 3.4557 20.5441C5.3757 22.3681 7.7277 23.5201 10.1277 23.9041Z",
    fill: "#5E6AD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10402_25042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgLinearIcon as ReactComponent };
export default __webpack_public_path__ + "linear-icon.svg";